import URLS from '@/server/urls';
import { modal } from '@/share/components';
import { useAuthorStore } from '@/stores';

/**
 * @description 导出到Excel函数
 * @returns {{exportProjKpiMonitorExcel: exportProjKpiMonitorExcel}}
 */
export const useExportToExcel = () => {
    const authorStore = useAuthorStore();

    // 导出项目绩效表到Excel
    const exportProjKpiExcel = (projId) => {
        if (!projId) {
            modal.notification.warning('绩效表ID无效，不能导出', '导出绩效表').catch();
            return;
        }
        const url = `${URLS.kpi.projKpiItem.excel}/${projId}?access-token=${authorStore.token}`;
        window.open(url, '_blank');
    };

    // 导出项目目标监控表到Excel
    const exportProjKpiMonitorExcel = (id) => {
        if (!id) {
            modal.notification.warning('监控表ID无效，不能下载', '下载监控表').catch();
            return;
        }
        const url = `${URLS.kpi.projMonitor.excel}/${id}?access-token=${authorStore.token}`;
        window.open(url, '_blank');
    };
    return {
        exportProjKpiExcel,
        exportProjKpiMonitorExcel,
    };
};
